import React from 'react';
import { Link } from 'react-router-dom';
import './HeaderLegal.css';

export const HeaderLegal = () => {
  return (
    <header className="header-legal">
      <div className="header-legal-content">
        <img src="/Images/logo_sinback.png" alt="Closer Academy Logo" className="header-legal-logo-img" />
        <Link to="/" className="header-legal-logo">
          CloserAcademy
        </Link>
      </div>
    </header>
  );
};

